<template>
  <div>
    <h4 class="mb-4 text-center text-uppercase"></h4>
    <b-button type="button" v-on:click="onAdd()" class="btn-lg btn-full-width" v-di variant="primary">Nuovo prodotto</b-button>
    <hr/>
    <b-button type="button" v-on:click="onCheckout()" class="btn-lg btn-full-width" v-di variant="primary" v-if="hasProduct() > 0">
      <b-icon-card-checklist></b-icon-card-checklist>
      Val al Carrello <small v-if="getProductsInCart.length == 1">( {{ getProductsInCart.length }} articolo
      )</small><small
        v-if="getProductsInCart.length > 1">( {{ getProductsInCart.length }} articoli )</small></b-button>
    <hr v-show="hasProduct() > 0"/>
    <b-button type="button" v-on:click="onOrders()" class="btn-lg btn-full-width" v-di variant="secondary">Archivio ordini</b-button>
    <br/>
    <br/>
    <p>
      <router-link to="/login">Logout</router-link>
    </p>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import {router} from "@/_helpers";

export default {
  computed: {
    ...mapState({
      account: state => state.account,
      cart: state => state.account
    }),
    ...mapGetters('cart', [
      'getProductsInCart',
    ])
  },
  methods: {
    hasProduct() {
      return this.getProductsInCart.length > 0;
    },
    onOrders(){
      router.push('/orders');
    },
    onCheckout() {
      router.push('/checkout');
    },
    onAdd() {
      router.push('/add');
    }
  }
};
</script>